
import { useDispatch, useSelector } from "react-redux";

import IdentButtons from './helper/IdentButtons';
import IdentShowScreenShot from "./helper/IdentShowScreen";
import LastScreenTaken from "./helper/LastScreenTaken";
import ModalTakeScreen from "./helper/ModalTakeScreen";
import IdentShowIDAustriaLoader from "./helper/IdentShowIDAustriaLoader";
import IdentShowIDAustriaData from "./helper/IdentShowIDAustriaData";
import TimerDisplay from "./helper/TimerDisplay";

import { Avatar,Indicator, Group, Grid, Tooltip, Alert, Center, Image, createStyles, ScrollArea, Button, rem} from '@mantine/core';
import { AlertTriangle,Checkbox, DeviceComputerCamera } from 'tabler-icons-react';

import { clear_Acc_InProgress,clear_screenshoterror,remove_klientidAustriaaccept } from "../slice/mainslice";

import { useState } from "react";
import intl from "react-intl-universal";

import idaustrialogo from '../images/idaustriaw.png' 

const useStyles = createStyles((theme) => ({
  overdiv: {
    position: 'relative',
    display: 'inline-block',

  },
  posidaustria: {
    position: 'absolute',
    display: 'inline-block',
    top: "-2px",
    left:"-10px",
  },
  posiok: {
    position: 'absolute',
    display: 'inline-block',
    top: "40px",
    left:"-3px",
    backgroundColor: "white",
  },
  screenok: {
    position: 'absolute',
    display: 'inline-block',
    top: "15px",
    left:"-12px",
    backgroundColor: "white",
  },
  scrollpad: {
    margin: '5px',
  },
  textsize: {
    fontSize: rem('16px'),
    [theme.fn.smallerThan('lg')]: {
      fontSize: rem('10px'),
    },
  },
}));




const IdentCheck = (props:any) => {  
  const dispatch = useDispatch()
  const { classes } = useStyles();
  const initparticipants = useSelector((state: any) => state.user.meetinguser)
  const confirminprogress = useSelector((state: any) => state.user.activconfirmuser)
  const sherror = useSelector((state: any) => state.user.screeshoterror) 
  const idaustrialoader = useSelector((state: any) => state.user.idAustriadataloading) 
  const klientidAustriaaccept = useSelector((state: any) => state.user.klientidAustriaaccept) 
  const screenshots = useSelector((state: any) => state.user.identscreenshots)
  const newscreenshots = useSelector((state: any) => state.user.newscreenshot)
  const idaustriadata = useSelector((state: any) => state.user.idAustriadata)
  const accinProgress = useSelector((state: any) => state.user.accinProgress)

  const [openscreen, setOpenscreen] = useState(false);

  const [selectetuser, setSelecteduser] = useState("");

  



  let showscrollbar = false
  if (props.divheight > 420 && accinProgress !== "") {
    showscrollbar = true
  }
  

   const handlesetSelecteduser = (meetingParticipantId: any) => {
     console.log("Hit HandlesetSelecteduser")
     
     setSelecteduser(meetingParticipantId);
   } 



    // Modal Screens
    const handleOpenscreen = () => {
      setOpenscreen(true);
    };
  
    const handleClosescreen = () => {
      setOpenscreen(false);
    }; 

    const clearerror = () => {
        dispatch(clear_screenshoterror())
    }

    const cleardrnerror = (meetingParticipantId: any) => {
         const removepayload ={
          meetingParticipantId: meetingParticipantId,
          }
          console.log(removepayload)
         
      dispatch(remove_klientidAustriaaccept(removepayload))
    }
  
  const data = initparticipants.filter((obj: { role: any; isToBeIdentified: boolean; }) => {
  return (obj.role !== "notar" && obj.role !== "gast") && obj.isToBeIdentified === true
  });



  let count = 0
  const rows = (data || []).map((item:any, index:any) => {
     // Make Initialen

    // console.log(item)
     
     let a = item.lastName.substring(0,1)
     let b = item.firstName.substring(0,1)
     let initialen = a + b
     let fullname = item.lastName + " " + item.firstName
    /*
    let statuscolor = "red"
    if (item.isLoggedIn) {
      statuscolor = "green"
    }
    if (!item.isLoggedIn) {
      statuscolor = "red"
    }
    */
    let inmeetingcolor = "red"
    if (item.meetingParticipantStatus === null) {
      inmeetingcolor = "red"
    }
    if (item.meetingParticipantStatus === "LeftMeeting") {
      inmeetingcolor = "red"
    }
    if (item.meetingParticipantStatus === "InMeeting") {
      inmeetingcolor = "green"
      count ++
    }

    // Ist der User bereits idendifiziert (true/false)
    // Filter auf das richtige Szenario
    const confirmedonefilter = item.actions.filter((obj: { scenarioId: any; }) => {
      return obj.scenarioId === props.scenarioId
      });
      
    let confirm = confirmedonefilter[0].isDone
    
    let sherrormessage = ""
    if (sherror !== ""){
      sherrormessage = sherror
    }

    // ID Austria 
    let loadidadata = false 
    let haveidaustriadata = false
    let currentidadata
    let idaustriaident


    if (item.idAustriaData !== null) {
     idaustriaident = item.idAustriaData.isIdentified
    }

    const currentlistloader = idaustrialoader.filter((obj: { meetingParticipantId: any; }) => {
      return obj.meetingParticipantId === item.id
    });
    
    if (currentlistloader.length !== 0) {
        loadidadata = currentlistloader[0].isRequestAccepted
      }

    if (idaustriadata.length !== 0) {
        currentidadata = idaustriadata.filter((obj: { participantModel: any; }) => {
        return obj.participantModel.id === item.id
      });  

    if (currentidadata.length === 1) {
      loadidadata = false
      haveidaustriadata = true
    } 

    } 


  // Check if KLient have trigger popum in DRN  
  let klientIDAaccept

 // console.log(klientidAustriaaccept)

  const currenttriggerdrnpopup = klientidAustriaaccept.filter((obj: { meetingParticipantId: any; }) => {
    return obj.meetingParticipantId === item.id
  });

  if (currenttriggerdrnpopup.length !== 0) {
    klientIDAaccept = currenttriggerdrnpopup[0].isRequestAccepted
  }

  



    
  // Check if Screenshots exist
  let showscreenicon = false  
  const havescreendata = screenshots.filter((obj: { userParticipantId: any }) => {
      return obj.userParticipantId === item.id 
  });

  if (havescreendata.length > 0) {
    showscreenicon = true
  }



 let avatervariant = "outline"
 if (confirm && item.meetingParticipantStatus === "InMeeting"){
    avatervariant = "outline"
 }




 
 //console.log("----------------------------------")
 //console.log("item.id ->",item.id)
 //console.log("selecteduser ->",selectetuser)
 //console.log("showopendetailbutton",showopendetailbutton)
 //console.log("idaustriadata", idaustriadata)
 //console.log("currentidadata", currentidadata)
 //console.log("idaustriaident",  idaustriaident)
// console.log("----------------------------------")


    return (
  <div key={item.id}> 
    <Grid   className={classes.scrollpad}>
    <Grid.Col xs={12}  md={4} lg={4} xl={3}>
        
        <div className={classes.overdiv} >
         <Indicator inline size={16} offset={7} position="bottom-end" color={inmeetingcolor} withBorder>
               <Avatar  alt={fullname} variant={avatervariant} radius="xl" size="lg" >
                 {initialen} 
                 </Avatar> 
           </Indicator>
         
           {idaustriaident && item.meetingParticipantStatus === "InMeeting" && idaustriaident !== undefined && 
                 <Tooltip label={intl.get('IDA_DATA_CONFIRMED')} >
                 <Image
                 height={15}
                 width={31}
                   src={idaustrialogo}
                   className={classes.posidaustria}
                   />
                 </Tooltip>  
           } 
         
           {confirm && item.meetingParticipantStatus === "InMeeting" &&
                  <Tooltip label={intl.get('IDENTCHECK_TT_USER_ISIDENT')} >
                   <span>
                    <Checkbox size={20} strokeWidth={1} color="green" className={classes.posiok} />
                   </span>
                 </Tooltip>
           }
 
           {showscreenicon && item.meetingParticipantStatus === "InMeeting" &&
               <Tooltip label={intl.get('IDENTCHECK_TT_HAVESCREENSHOTS')} >
                   <span>
                    <DeviceComputerCamera size={20} strokeWidth={1} color="green" className={classes.screenok} />
                   </span>
                 </Tooltip>
           }
 
       </div>    
        
     
 
         
           
     </Grid.Col>
     <Grid.Col  xs={12} md={8} lg={8} xl={4}> 
         <Group>
           <span className={classes.textsize}>{fullname}</span>
          </Group>
           
           <IdentShowScreenShot meetingParticipantId={item.id}/>
     
     </Grid.Col>
            <Grid.Col xs={12} md={12} lg={12} xl={5}>
               <Group  spacing={5} mt={2} position="right">
 
              
 
                 
                 {item.meetingParticipantStatus === "InMeeting" && 
                 <IdentButtons meetingParticipantId={item.id} scenarioId={props.scenarioId} sceneId={props.sceneId} confirm={confirm} idaustriaident={idaustriaident} loadidadata={loadidadata} handleOpenscreen={handleOpenscreen} handleClosescreen={handleClosescreen} openscreen={openscreen} handlesetSelecteduser={handlesetSelecteduser} selectetuser={selectetuser}/>
                 }
                 {item.meetingParticipantStatus === null && 
                  <Tooltip label={intl.get('IDENTCHECK_TT_USER_NOTONLINE')} multiline={true}>
                   <span>
                    <AlertTriangle size={38} strokeWidth={1} color="red" />
                   </span>
                 </Tooltip>
                 } 
                 {item.meetingParticipantStatus === "LeftMeeting" && 
                  <Tooltip label={intl.get('IDENTCHECK_TT_USER_NOTONLINE')} multiline={true}>
                   <span>
                     <AlertTriangle size={38} strokeWidth={1} color="red" />
                   </span>
                </Tooltip>
                 }
                 {confirm && item.meetingParticipantStatus === "LeftMeeting" &&
                  <Tooltip label={intl.get('IDENTCHECK_TT_USER_ISIDENT')} multiline={true}>
                   <span>
                     <Checkbox size={38} strokeWidth={1} color="green"/>
                   </span>
                </Tooltip>
                 }
                 {idaustriaident && item.meetingParticipantStatus === "LeftMeeting" && idaustriaident !== undefined &&
                  <Tooltip label={intl.get('IDA_DATA_CONFIRMED')} multiline={true}>
                  <Image
                  height={20}
                  width={43}
                  src={idaustrialogo}
                    />
                  </Tooltip>  
                 }
                 
                 
 
           </Group>
     </Grid.Col>
  </Grid>
  
  <Grid key={item.id+"ident"}>
  <Grid.Col span={12}>

  {item.id === confirminprogress && sherror !== "" &&
    <>
    <hr />
     <Center >
     <Alert onClose={() => clearerror()} icon={<AlertTriangle size="1rem" />} title={intl.get('ERROR_SCREENSHOT')} color="red" withCloseButton >
       <span>{sherrormessage}</span>
       <hr />
       <Button fullWidth  variant="outline" color="gray" onClick={() => clearerror()}>{intl.get('CLEARSCREENSHOT_ERROR_BUTON')}</Button>
      </Alert>
    </Center>
    <hr />
      </>
     }
  

  
    
  {item.id === confirminprogress && loadidadata && 
    <>
    {klientIDAaccept === undefined &&
       <TimerDisplay seconds={60} meetingParticipantId={item.id} klientIDAaccept={klientIDAaccept} timerview="pop"/>
    }

    
    {klientIDAaccept !== undefined && !klientIDAaccept && // Überprüfen!!! diese BEdingung kann nicht erfüllt sein
      <Center >
      <Alert onClose={() => cleardrnerror(item.id)} icon={<AlertTriangle size="1rem" />} title={intl.get('IDA_LOADER_KLIENTDRN_POPNO_HEAD')} color="red" withCloseButton >
        <span>{intl.get('IDA_LOADER_KLIENTDRN_POPNO')}</span>
        <hr />
        <Button fullWidth  variant="outline" color="gray" onClick={() => cleardrnerror(item.id)}>{intl.get('IDA_LOADER_CLIENT_MODAL_RESET')}</Button>
        </Alert>
      </Center>
    }

    {klientIDAaccept  &&
    <> 
    <IdentShowIDAustriaLoader />
    <TimerDisplay seconds={120} meetingParticipantId={item.id} klientIDAaccept={klientIDAaccept} timerview="loader"/>
    </>
    }
    </>
  }

        {item.id === confirminprogress && !loadidadata &&  haveidaustriadata &&
              <IdentShowIDAustriaData idaustriadata={currentidadata} MeetingParticipantId={item.id} />
        }
   
       {item.id === confirminprogress && item.meetingParticipantStatus !== "" &&
          <LastScreenTaken meetingParticipantId={item.id} handleOpenscreen={handleOpenscreen} handleClosescreen={handleClosescreen} />
        }
   
    {newscreenshots &&  
     <ModalTakeScreen meetingParticipantId={item.id}/>
    }
   
   </Grid.Col> 
  </Grid>
 
  </div> 
    );
  });

 // Clear aktiv User wenn niemand eingelogged ist
 /*
 if (count === 0){
  if (accinProgress !== ""){
   dispatch(clear_Acc_InProgress())
  }
 }*/


  return ( 
    <>
      <hr />
      {!showscrollbar &&
      <>
        {rows}
      </>
      }
      {showscrollbar &&
      <>
      <ScrollArea h={420} type="hover" offsetScrollbars>
        {rows}
      </ScrollArea>
      </>
      }
    </>
  );
}

export default IdentCheck;